<div data-automation="productHomePageFieldsPanel" ngModelGroup="homePageFields">
  <ng-container>
    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
      (afterExpand)="onPanelExpand()"
      (afterCollapse)="onPanelExpand()"
      togglePosition="before"
      class="expansion-panel"
      id="product-homepage-panel"
      data-automation="productHomePagePanel"
    >
      <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
        <mat-panel-title class="panel-title">
          <div data-automation="productHomePagePanelTitle">
            {{ 'common.product.home_page_configuration' | translate }}
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!--- CREATE/EDIT --->
      <div *ngIf="(isCreateMode || isEditMode) && product && product.prezConf" class="panel-content">
        <div class="form-group">

          <div class="hours-wrapper">
            <!--- Program Hours Type (dropdown) --->
            <div class="form-entry">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{ 'common.home_page_config.program_hours_type' | translate }}</mat-label>
                <mat-select
                  id="programHoursType"
                  name="programHoursType"
                  #programHoursTypeCtrl="ngModel"
                  [ngModel]="programHoursType"
                  (selectionChange)="onProgramHoursTypeChange($event.value)"
                  data-automation="programHoursTypeSelector"
                  data-url-persist
                  placeholder="{{ 'product.create.placeholder.program_hours_type' | translate }}"
                >
                  <mat-option [value]="null">
                    {{ 'product.create.placeholder.program_hours_type' | translate }}
                  </mat-option>
                  <mat-option
                    *ngFor="let option of programHoursOptions"
                    [value]="option.code"
                    id="{{ option.code }}"
                  >
                    {{ option.translationKey | translate }}
                  </mat-option>
                </mat-select>

                <mat-icon
                  matSuffix
                  svgIcon="enelx:general-info"
                  data-automation="programHoursTypeTooltip"
                  class="tooltip-icon"
                  [matTooltipPosition]="'below'"
                  matTooltip="{{ 'common.home_page_config.program_hours_type.tooltip' | translate }}"
                ></mat-icon>

                <mat-error *ngIf="programHoursTypeCtrl.invalid" class="alert alert-danger">
                </mat-error>
              </mat-form-field>
            </div>

            <!--- Program Hours CRON (text) --->
            <!-- Shown only when a selection has been made in the dropdown. -->
            <!-- Editable only when "CUSTOM" is selected; required + CRON-validated when any option is selected. -->
            <div class="form-entry" *ngIf="isProgramHoursTypeSelected">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{ 'common.home_page_config.program_hours_cron' | translate }}</mat-label>
                <input
                  matInput
                  id="programHoursCron"
                  type="text"
                  #programHoursCron="ngModel"
                  name="programHoursCron"
                  placeholder="* * * ? * *"
                  maxlength="64"
                  [(ngModel)]="product.prezConf.programHours"
                  [disabled]="!isCustomProgramHours"
                  [required]="isProgramHoursTypeSelected"
                  data-automation="programHoursCron"
                  data-url-persist
                  homepageCronValidator
                />

                <mat-icon
                  matSuffix
                  svgIcon="enelx:general-info"
                  data-automation="programHoursCronTooltip"
                  class="tooltip-icon"
                  [matTooltipPosition]="'below'"
                  matTooltip="{{ 'common.home_page_config.program_hours_cron.tooltip' | translate }}"
                ></mat-icon>

                <mat-error *ngIf="programHoursCron.invalid" class="alert alert-danger">
                  <mat-error *ngIf="programHoursCron.errors?.required">
                    <span class="input-entry">{{ 'common.validation.required' | translate }}</span>
                  </mat-error>
                  <mat-error *ngIf="programHoursCron.errors?.homepageCronValidator">
                    <span data-automation="invalidCRONExpressionError" class="input-entry">{{ 'common.home_page_config.program_hours_cron.invalid' | translate }}</span>
                  </mat-error>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="checkboxes-wrapper">
            <!--- ERP --->
            <div class="form-entry">
              <div class="checkbox-wrapper">
                <mat-checkbox
                  id="erp"
                  #erp="ngModel"
                  class="input-entry checkbox-container"
                  name="erp"
                  [(ngModel)]="product.prezConf.displayErpHomepage"
                  data-automation="erp"
                  data-url-persist
                >
                  {{ 'common.home_page_config.erp' | translate }}
                </mat-checkbox>

                <mat-icon
                  svgIcon="enelx:general-info"
                  data-automation="erpTooltip"
                  class="tooltip-icon icon-container"
                  [matTooltipPosition]="'below'"
                  matTooltip="{{ 'common.home_page_config.erp.tooltip' | translate }}"
                ></mat-icon>
              </div>
            </div>

            <!--- Dispatch Likelihood --->
            <div class="form-entry">
              <div class="checkbox-wrapper">
                <mat-checkbox
                  id="dispatchLikelihood"
                  #dispatchLikelihood="ngModel"
                  class="input-entry checkbox-container"
                  name="dispatchLikelihood"
                  [(ngModel)]="product.prezConf.displayDispatchForecastHomepage"
                  data-automation="dispatchLikelihood"
                  data-url-persist
                >
                  {{ 'common.home_page_config.dispatch_likelihood' | translate }}
                </mat-checkbox>

                <mat-icon
                  svgIcon="enelx:general-info"
                  data-automation="dispatchLikelihoodTooltip"
                  class="tooltip-icon icon-container"
                  [matTooltipPosition]="'below'"
                  matTooltip="{{ 'common.home_page_config.dispatch_likelihood.tooltip' | translate }}"
                ></mat-icon>
              </div>
            </div>

            <!--- Show Holidays --->
            <div class="form-entry">
              <div class="checkbox-wrapper">
                <mat-checkbox
                  id="showHolidays"
                  #showHolidays="ngModel"
                  class="input-entry checkbox-container"
                  name="showHolidays"
                  [(ngModel)]="product.prezConf.displayHolidaysDispatchForecastHomepage"
                  data-automation="showHolidays"
                  data-url-persist
                >
                  {{ 'common.home_page_config.show_holidays' | translate }}
                </mat-checkbox>

                <mat-icon
                  svgIcon="enelx:general-info"
                  data-automation="showHolidaysTooltip"
                  class="tooltip-icon icon-container"
                  [matTooltipPosition]="'below'"
                  matTooltip="{{ 'common.home_page_config.show_holidays.tooltip' | translate }}"
                ></mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--- VIEW --->
      <div *ngIf="isViewMode && product && product.prezConf" class="panel-content">
        <div class="form-group">

          <!--- Program Hours Type --->
          <div class="form-entry">
            <mat-label class="info-title"
            >{{ 'common.home_page_config.program_hours_type' | translate }}

              <mat-icon
                svgIcon="enelx:general-info"
                data-automation="programHoursTypeTooltip"
                class="tooltip-icon icon-container"
                [matTooltipPosition]="'below'"
                matTooltip="{{ 'common.home_page_config.program_hours_type.tooltip' | translate }}"
              ></mat-icon>
            </mat-label>
            <mat-label class="input-entry" data-automation="programHoursType">
              {{ programHoursTypeForProduct | translate }}
            </mat-label>
          </div>

          <!--- Program Hours CRON --->
          <div class="form-entry" *ngIf="isProgramHoursTypeSelected">
            <mat-label class="info-title"
            >{{ 'common.home_page_config.program_hours_cron' | translate }}

              <mat-icon
                svgIcon="enelx:general-info"
                data-automation="programHoursCronTooltip"
                class="tooltip-icon icon-container"
                [matTooltipPosition]="'below'"
                matTooltip="{{ 'common.home_page_config.program_hours_cron.tooltip' | translate }}"
              ></mat-icon>
            </mat-label>
            <mat-label class="input-entry" data-automation="programHoursCron">
              {{ product.prezConf.programHours }}
            </mat-label>
          </div>

          <!--- ERP --->
          <div class="form-entry">
            <mat-label class="info-title"
            >{{ 'common.home_page_config.erp' | translate }}

              <mat-icon
                svgIcon="enelx:general-info"
                data-automation="erpTooltip"
                class="tooltip-icon icon-container"
                [matTooltipPosition]="'below'"
                matTooltip="{{ 'common.home_page_config.erp.tooltip' | translate }}"
              ></mat-icon>
            </mat-label>
            <mat-label class="input-entry" data-automation="erp">
              {{ product.prezConf.displayErpHomepage }}
            </mat-label>
          </div>

          <!--- Dispatch Likelihood --->
          <div class="form-entry">
            <mat-label class="info-title"
            >{{ 'common.home_page_config.dispatch_likelihood' | translate }}

              <mat-icon
                svgIcon="enelx:general-info"
                data-automation="dispatchLikelihoodTooltip"
                class="tooltip-icon icon-container"
                [matTooltipPosition]="'below'"
                matTooltip="{{ 'common.home_page_config.dispatch_likelihood.tooltip' | translate }}"
              ></mat-icon>
            </mat-label>
            <mat-label class="input-entry" data-automation="dispatchLikelihood">
              {{ product.prezConf.displayDispatchForecastHomepage }}
            </mat-label>
          </div>

          <!--- Show Holidays --->
          <div class="form-entry">
            <mat-label class="info-title"
            >{{ 'common.home_page_config.show_holidays' | translate }}

              <mat-icon
                svgIcon="enelx:general-info"
                data-automation="showHolidaysTooltip"
                class="tooltip-icon icon-container"
                [matTooltipPosition]="'below'"
                matTooltip="{{ 'common.home_page_config.show_holidays.tooltip' | translate }}"
              ></mat-icon>
            </mat-label>
            <mat-label class="input-entry" data-automation="showHolidays">
              {{ product.prezConf.displayHolidaysDispatchForecastHomepage }}
            </mat-label>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </ng-container>
</div>